<template>
  <div class="container" :class="{ 'container-img': !showShareBtn }" ref="box">
    <img
      v-if="hasAiReview"
      class="ai-review-entry-img"
      src="https://cdnvue.gymcity.com.cn/uploads/ai-outline-details-tongguo"
      alt=""
      @click="handleAiReviewClick"
    />
    <AiReviewPopup :visible.sync="showAiReview" :plan="plan" />
    <div class="nps-panel nps-top" :class="{ 'nps-top-no-mt': hasAiReview }">
      <div class="top-info">
        <div class="info-left">
          <div class="left-course">
            我的第
            <span>{{ courses }}</span> 次训练计划
          </div>
          <div class="left-time" v-if="plan.s_year">
            {{ plan.s_year + '.' + plan.s_month }}期训练
          </div>
        </div>
        <img
          class="info-img"
          :src="
            plan.image
              ? plan.image
              : 'https://cdnvue.gymcity.com.cn/uploads/pub-red-logo'
          "
          alt
        />
      </div>
      <div class="currprogress-region">
        <div
          class="progress-pop"
          :style="courses ? 'left:' + currprogress : ''"
        >
          已完成
          <span>{{ currprogress }}</span>
          <div class="border-down-empty">
            <span></span>
          </div>
        </div>
        <div
          class="progress"
          :style="courses ? 'width:' + currprogress : ''"
        ></div>
      </div>
      <div class="progress-text">
        <span>已上课{{ plan.scan_class }}节</span>
        <span>总课时{{ plan.total_class || 12 }}节</span>
      </div>
    </div>
    <div class="nps-panel nps-position">
      <div class="position-title">本课时训练概述</div>
      <div class="position-item">
        训练部位：
        <span>{{ positionData.join('，') }}</span>
      </div>
      <gym-position
        :position="positionData"
        :gender="plan.outline.gender == 'M' ? '1' : '2'"
      ></gym-position>
      <div class="position-item position-item-1">
        训练模式
        <span>{{ plan.outline.r_1 || '' }}</span>
      </div>
      <div class="position-item">
        训练目标
        <span>{{
          (plan.is_test == 1 ? '体测 + ' : '') + (plan.target || '')
        }}</span>
      </div>
    </div>
    <div class="nps-panel nps-act">
      <div class="act-title">热身动作组</div>
      <template v-if="wormActList && wormActList.length > 0">
        <div
          class="act-item"
          @click="onActItem(item)"
          v-for="(item, index) in wormActList"
          :key="index"
        >
          <div class="item-title">
            <div class="t-dot"></div>
            <div class="t-text">{{ item.a_name }}</div>
          </div>
          <div class="item-cent">
            <div class="cent-tag">
              <span>{{ item.l_text }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="nps-panel nps-act">
      <div class="act-title">主体动作组</div>
      <template v-if="actionList && actionList.length > 0">
        <div
          class="act-item"
          @click="onActItem(item)"
          v-for="(item, index) in actionList"
          :key="index"
        >
          <div class="item-title">
            <div class="t-dot"></div>
            <div class="t-text">{{ item.a_name }}</div>
          </div>
          <div class="item-cent">
            <div class="cent-tag">
              <span>{{ item.l_text }}</span>
            </div>
            <div class="cent-desc" v-if="item.actionText">
              <span>{{ item.actionText }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="nps-panel nps-act">
      <div class="act-title">运动后拉伸</div>
      <div class="act-item">
        <div class="item-title">
          <div class="t-dot"></div>
          <div class="t-text">
            <span class="action">被动拉伸时长</span>
            <span class="sub-t">{{ plan.draw_time + '分钟' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="nps-panel nps-act">
      <div class="act-title">有氧训练</div>
      <div class="act-item">
        <div class="item-title">
          <div class="t-dot"></div>
          <div class="t-text">
            <span class="action">建议控制心率</span>
            <span class="sub-t">{{ plan.aerobic_heart_rate + '次/分' }}</span>
          </div>
        </div>
      </div>
      <div class="act-item">
        <div class="item-title">
          <div class="t-dot"></div>
          <div class="t-text">
            <span class="action">建议有氧时长</span>
            <span class="sub-t">{{ plan.aerobic_time + '分钟' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="cps-noplan-btn" v-if="showOutlineBtn" @click="goToOutline"
      >查看训练大纲</div
    >
  </div>
</template>

<script>
import GymPosition from '@/components/GymPosition'
import AiReviewPopup from './components/AiReviewPopup.vue'
export default {
  components: {
    GymPosition,
    AiReviewPopup
  },
  data() {
    return {
      showAiReview: false,
      showTips: false,
      imgUrl: null,
      timeOutEvent: 0,
      showMask: false,
      showShareBtn: true,
      currprogress: '0%',
      plan: {
        question: [],
        require: [],
        s_year: '',
        s_month: '',
        outline: {
          truename: ' ',
          r_1: ' ',
          gender: ''
        },
        worm_act: [],
        body_act: []
      },
      ufrom: this.$route.query.ufrom || 'vip', // 当前用户来源 身份 vip 为会员用户 user 为上课教练
      showOutlineBtn: this.$route.query.showOutlineBtn || false // 是否显示查看训练大纲按钮
    }
  },
  beforeRouteEnter(to, from, next) {
    const { pid = '' } = to.query || {}
    if (pid && pid.indexOf(':') > -1) {
      next({
        path: '/newplanshow',
        query: to.query || {}
      })
    } else {
      next()
    }
  },
  created() {
    this.getPlan()
    this.$http.get('member/index?a=shareLogPush', {
      from: `训练计划页-曝光`,
      from_id: 2026052813
    })
  },
  computed: {
    hasAiReview() {
      return (
        this.plan.check_err_id > 0 &&
        (this.plan.run_flag == 1 || this.plan.run_flag == 3)
      )
    },
    courses: function () {
      return Number(this.plan.plan_num ? this.plan.plan_num : 0)
    },
    actionList() {
      const {
        // 主体动作
        body_act: bodyAct = []
      } = this.plan
      const list = bodyAct.map((item) => {
        const actionText = `${item.last_groups}组，每组${
          item.last_time === 0 ? '' : item.last_time + '秒'
        }${item.last_times === 0 ? '' : item.last_times + '次'}，组间休息${
          item.rest_time
        }秒${this.ufrom == 'vip' ? '' : `，RPE${item.last_rpe}分`}`
        return { ...item, actionText }
      })
      return list
    },
    wormActList() {
      const {
        // 热身动作
        worm_act: wormAct = []
      } = this.plan
      return wormAct
    },
    positionData: {
      get() {
        this.$forceUpdate()
        let temp = []
        if (this.actionList.length >= 1) {
          this.actionList.map((v) => {
            ;(v.a_position || []).map((p) => {
              if (temp.indexOf(p) === -1) {
                temp.push(p)
              }
            })
          })
        }
        return temp
      },
      set() {}
    }
  },
  methods: {
    /**
     * 点击AI审核入口
     */
    handleAiReviewClick() {
      this.$http.get('member/index?a=shareLogPush', {
        from: `训练计划页-健萌AI审核-点击`,
        from_id: 2026052813
      })
      this.showAiReview = true
    },
    /**
     * 查看动作详情
     */
    onActItem(act) {
      // VIP : 会员  user : 上课教练
      if (this.ufrom !== 'vip') {
        const { video_url, imgs_url, a_name, a_item, a_position } = act
        // eslint-disable-next-line camelcase
        const imgs =
          Array.isArray(imgs_url) && imgs_url.length === 0 ? '' : imgs_url
        const obj = {
          a_video: video_url,
          a_img_num: imgs,
          a_name: a_name,
          a_item: a_item,
          a_position: a_position
        }
        this.$store.commit('setActDetail', obj)
        this.$router.push({ path: '/newactdetail' })
      }
    },
    // init(id) {
    //   this.getPlan(id)
    // },
    getPlan() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      this.$http
        .get(
          'plan/OutlineUp',
          { a: 'planDetail', pid: this.$route.query.pid },
          true
        )
        .then((res) => {
          this.$toast.clear()
          console.log('res', res)
          if (res.data.code === 200) {
            this.plan = res.data.data || {}
            // AI审核埋点
            if (
              this.plan.check_err_id > 0 &&
              (this.plan.run_flag == 1 || this.plan.run_flag == 3)
            ) {
              this.$http.get('member/index?a=shareLogPush', {
                from: `训练计划页-健萌AI审核-曝光`,
                from_id: 2026052813
              })
            }
            setTimeout(() => {
              this.currprogress =
                (
                  (this.plan.scan_class / (this.plan.total_class || 12)) *
                  100
                ).toFixed(0) + '%'
            }, 500)
            this.plan.image = this.plan.image
              ? this.plan.image.replace(
                  'http://thirdwx.qlogo.cn',
                  location.origin + '/wechat_image'
                )
              : ''
          }
        })
    },
    goToOutline() {
      this.$router.push(`/newoutline?uid=${this.plan.outline.uid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.container {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  z-index: 14;
  text-align: left;
  background-color: #f7f7f7;
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: vw(90);
  padding-bottom: calc(#{vw(90)} + constant(safe-area-inset-bottom));
  padding-bottom: calc(#{vw(90)} + env(safe-area-inset-bottom));
  // IOS底部安全兼容
  box-sizing: border-box;
  .nps-panel {
    width: 91.5vw;
    background-color: #ffffff;
    border-radius: 1.6vw;
    border: solid 0.3vw #f1f1f1;
    padding: 4.5vw 6vw;
    box-sizing: border-box;
    margin-top: 2.7vw;
  }
  .nps-top {
    .top-info {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info-left {
        text-align: left;
        flex: 1;
        .left-course {
          font-size: 5.3vw;
          font-weight: 600;
          span {
            color: #dc0050;
          }
        }
        .left-time {
          font-size: 3.7vw;
          color: rgba(0, 0, 0, 0.5);
          margin-top: 0.3vw;
        }
      }
      .info-img {
        width: 10.7vw;
        height: 10.7vw;
        border-radius: 50%;
        // background-color: #f1f1f1;
      }
    }
    .currprogress-region {
      width: 100%;
      box-sizing: border-box;
      height: 1.9vw;
      background: #d8d8d8;
      border-radius: 0.8vw;
      margin-top: 9.1vw;
      position: relative;
      .progress-pop {
        background-color: #fff;
        border: solid 1px #e7e7e7;
        border-radius: 1vw;
        padding: 0.3vw 2vw;
        box-sizing: border-box;
        font-size: 2.7vw;
        font-weight: 600;
        position: absolute;
        top: -7.5vw;
        left: 1%;
        transform: translateX(-50%);
        span {
          color: #dc0050;
        }
        .border-down-empty {
          content: '';
          width: 0;
          height: 0;
          // border-bottom: vw(10) solid transparent;
          // border-top: vw(10) solid #fff;
          // border-left: vw(10) solid transparent;
          // border-right: vw(10) solid transparent;
          // border: vw(1) solid #e7e7e7;
          position: absolute;
          bottom: vw(-5);
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: vw(5) solid transparent;
          border-right: vw(5) solid transparent;
          border-top: vw(5) solid #e7e7e7;
        }
        .border-down-empty span {
          display: block;
          width: 0;
          height: 0;
          border-left: vw(4.5) solid transparent;
          border-right: vw(4.5) solid transparent;
          border-top: vw(4.5) solid #fff;
          position: absolute;
          left: vw(-4.5);
          top: vw(-5);
        }
      }
      .progress {
        background-color: #dc0050;
        height: 100%;
        border-radius: 0.8vw;
        transition: width 1s ease-out;
        width: 1%;
      }
    }
    .progress-text {
      width: 100%;
      text-align: left;
      font-size: 3.2vw;
      box-sizing: border-box;
      margin-top: 1.5vw;
      display: flex;
      justify-content: space-between;
    }
  }
  .nps-position {
    .position-title {
      font-size: 4.3vw;
      font-weight: 600;
    }
    .position-item {
      display: flex;
      align-items: center;
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.5);
      margin-top: 4vw;
      span {
        flex: 1;
        font-size: 3.5vw;
        color: #000;
        margin-left: 2.2vw;
        font-weight: 600;
      }
    }
    .position-item-1 {
      margin-top: 0;
    }
  }
  .nps-act {
    .act-title {
      font-size: 4.3vw;
      font-weight: 600;
    }
    .act-item {
      width: 100%;
      box-sizing: border-box;
      margin-top: 5.9vw;
      .item-title {
        display: flex;
        align-items: center;
        .t-dot {
          width: 3.2vw;
          height: 3.2vw;
          background-color: #ffffff;
          border: solid 0.8vw #dc0050;
          box-sizing: border-box;
          border-radius: 50%;
        }
        .t-text {
          flex: 1;
          font-size: 4vw;
          margin-left: 4vw;
          font-weight: 600;
          display: flex;
          align-items: center;
          .sub-t {
            font-size: 3.2vw;
            font-weight: 400;
            margin-left: 3vw;
          }
        }
      }
      .item-cent {
        position: relative;
        margin-left: 7.2vw;
        .cent-tag {
          margin-top: 0.8vw;
          color: rgba(0, 0, 0, 0.5);
          font-size: 3.2vw;
        }
        .cent-desc {
          background-color: #f7f7f7;
          border-radius: 1.1vw;
          border: solid 0.3vw #f1f1f1;
          margin-top: 2.7vw;
          font-size: 3.2vw;
          color: #000;
          padding: 1.1vw 3.2vw;
          box-sizing: border-box;
          font-family: Din;
        }
      }
      .item-cent::after {
        content: '';
        height: 100%;
        border-left: dashed 0.5vw #dddddd;
        position: absolute;
        top: 0;
        left: -5.8vw;
      }
      .item-cent::before {
        content: '';
        border-left: solid 1.35vw transparent;
        border-top: solid 1.9vw #d8d8d8;
        border-right: solid 1.35vw transparent;
        border-bottom: solid 1.9vw transparent;
        position: absolute;
        bottom: -2.2vw;
        left: -6.9vw;
        z-index: 1;
      }
    }
  }
  .tips {
    background: rgba(229, 0, 73, 0.2);
    box-shadow: 0 0 0 0 #cccccc;
    text-align: center;
    width: 100%;
    // height: vw(28);
    // line-height: vw(29);
    color: #fff;
    font-size: vw(10);
    box-sizing: border-box;
    text-align: left;
    padding: vw(4) vw(10);
  }
  .hs-btn {
    width: vw(100/2);
    height: vw(100/2);
    border-radius: 50%;
    font-size: vw(28/2);
    font-weight: 450;
    // position: fixed;
    // right: vw(10);
    // bottom: vw(180);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ec7a9f;
  }
  header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    padding: vw(4) vw(12);
    position: relative;
    box-sizing: border-box;
    i {
      font-weight: 900;
      font-size: vw(20);
      padding: vw(5) vw(30);
    }
    .title {
      // font-weight: bold;
      color: #dc0050;
      font-size: vw(14);
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .right {
      font-size: vw(15);
    }
  }
  .share-img {
    width: 0;
    // min-height: 100vh !important;
    position: absolute;
    // transform: rotate(180deg);
    top: 0;
    left: 0;
    transition: all 1.5s;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .on-share-img {
    width: 100vw;
    transform: rotate(360deg);
    transition: all 1.5s;
  }
  .header {
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .user-ques {
      width: 100%;
      padding: 0 vw(28);
      box-sizing: border-box;
      font-size: vw(12);
      margin-top: vw(4);
      .q-item {
        padding-bottom: vw(4);
        border-bottom: vw(1) solid #f5f5f5;
        margin-top: vw(4);
      }
    }
    .progress-head {
      width: 100%;
      text-align: left;
      font-size: vw(12);
      margin-bottom: vw(8);
      padding: 0 vw(28);
      box-sizing: border-box;
    }
    .currprogress-region {
      width: vw(321);
      height: vw(6);
      // position: relative;
      background: #d8d8d8;
      // top: vw(1054);
      border-radius: vw(8/2);
      // left: vw(73);
      .progress {
        // position: absolute;
        // top: 50%;
        // left: 0;
        // transform: translateY(-50%);
        background-color: #dc0050;
        height: 100%;
        border-radius: vw(8/2);
        transition: width 1s ease-out;
        width: 1%;
      }
    }
    .progress-text {
      width: 100%;
      text-align: left;
      font-size: vw(12);
      // margin-bottom: vw(8);
      padding: 0 vw(28);
      box-sizing: border-box;
      margin-top: vw(4);
      display: flex;
      justify-content: space-between;
    }
  }
  .head-img {
    width: vw(48);
    height: vw(48);
    border-radius: 50%;
    margin-top: vw(15);
  }
  .name {
    font-size: vw(14);
    font-weight: 500;
    margin-top: vw(2);
  }
  .course {
    font-size: vw(14);
    font-weight: 500;
    // margin-bottom: vw(2);
    span {
      color: #dc0050;
      font-size: vw(26);
      margin: 0 vw(8);
    }
  }
  .top-time {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-bottom: vw(10);
    font-size: vw(10);
    .top-qishu {
      // background-color: #eaeaea;
      // border-radius: vw(13);
      font-size: vw(11);
      // padding: 0 vw(10);
      font-weight: 500;
      // margin-right: vw(5);
    }
  }
  .position-l {
    width: 100%;
    padding: vw(10) vw(24);
    padding-bottom: 0;
    margin-bottom: vw(10);
    background-color: #fff;
    box-sizing: border-box;
    .position-text {
      font-size: vw(15);
      font-weight: 600;
    }
    .position-desc {
      font-size: vw(12);
      color: #dc0050;
    }
  }
  .col {
    width: 100%;
    background-color: #fff;
    height: vw(40);
    line-height: vw(40);
    padding: 0 vw(15);
    box-sizing: border-box;
    font-size: vw(15);
    font-weight: 500;
    margin-bottom: vw(5);
    span {
      font-weight: 400;
    }
  }
  .panel {
    width: 100%;
    margin-bottom: vw(5);
    .title {
      font-size: vw(15);
      width: 100%;
      padding: 0 vw(15);
      box-sizing: border-box;
      height: vw(40);
      line-height: vw(41);
      font-weight: 600;
      text-align: left;
      background-color: #f5f5f5;
    }
    .aerobics-text {
      width: 100%;
      height: vw(44);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 vw(15);
      box-sizing: border-box;
      font-size: vw(15);
      font-weight: bold;
      background-color: #fff;
    }
    .act-item {
      width: 100%;
      background-color: #fff;
      padding: vw(10) vw(15);
      box-sizing: border-box;
      color: #4a4a4a;
      margin-bottom: vw(5);
      .act-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: vw(15);
        font-weight: 600;
        i {
          font-size: vw(18);
          color: #dc0050;
        }
      }
      .tags {
        font-size: vw(12);
        color: #9b9b9b;
        margin-top: vw(4);
        .number {
          color: #dc0050;
          font-weight: 500;
        }
      }
      .mode {
        background-color: #f5f5f5;
        padding: vw(5) vw(10);
        // color: #dc0050;
        font-weight: 600;
        font-size: vw(12);
        margin-top: vw(10);
      }
      .desc {
        background-color: #f5f5f5;
        padding: vw(5) vw(10);
        // font-weight: 600;
        font-size: vw(11);
        margin-top: vw(8);
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #fff;
    margin-top: 8vw;
    .f-right {
      display: flex;
      flex-direction: column;
      // align-items: center;
      text-align: left;
      img {
        width: 32.3vw;
        margin-top: 3.2vw;
      }
      .f-text {
        font-size: 3.2vw;
        color: #fff;
        text-align: center;
      }
    }
    #qrCode-canvas,
    .mini-qr-img {
      width: 17.1vw !important;
      height: 17.1vw !important;
      margin-right: 3.7vw;
      // background-color: #f00;
    }
    .qr-logo {
      position: absolute;
      width: vw(30);
      height: vw(30);
      right: vw(53);
      top: vw(53);
    }
  }
  .footer-btn {
    width: 100%;
    background-color: #dc0050;
    height: vw(40);
    text-align: center;
    line-height: vw(41);
    color: #fff;
    font-size: vw(16);
    font-weight: bold;
    position: fixed;
    bottom: 0;
    // IOS底部安全兼容
    bottom: calc(0.1px + constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    bottom: calc(0.1px + env(safe-area-inset-bottom)); //兼容 IOS>11.2
    z-index: 89;
  }
  .btn-float {
    width: 100vw;
    position: fixed;
    bottom: 0;
    // IOS底部安全兼容
    bottom: calc(0.1px + constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    bottom: calc(0.1px + env(safe-area-inset-bottom)); //兼容 IOS>11.2
    left: 0;
    z-index: 98;
  }
  .f-btns {
    width: 100%;
    box-sizing: border-box;
    height: vw(80);
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-top: 8vw;
    position: fixed;
    bottom: 0;
    // IOS底部安全兼容
    bottom: calc(0.1px + constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    bottom: calc(0.1px + env(safe-area-inset-bottom)); //兼容 IOS>11.2
    .btn-item {
      font-family: PingFang SC;
      font-size: 4vw;
      color: #dc0050;
      font-weight: 600;
      width: 44.5vw;
      height: 10.7vw;
      background-color: #ffffff;
      border-radius: 1.6vw;
      border: solid 0.3vw #dc0050;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn-item + .btn-item {
      margin-left: 2.4vw;
    }
    .btn-item-2 {
      background-color: #dc0050;
      color: #fff;
      z-index: 89;
    }
  }
  .pop-tips {
    width: 85%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    box-sizing: border-box;
    padding: vw(32) vw(24);
    background-color: #fff;
    border-radius: vw(8);
    color: #000;
    text-align: left;
    z-index: 100;
    font-size: 3.5vw;
    color: #000;
    line-height: 6vw;
    .pop-close-btn {
      bottom: vw(-100);
    }
    .tips-item {
      display: flex;
      .i-left {
        margin-right: 2.7vw;
      }
      .i-right {
        // font-weight: 600;
      }
    }
    .tips-item + .tips-item {
      margin-top: 4vw;
    }
  }
  .cps-noplan-btn {
    width: vw(300);
    height: vw(48);
    box-sizing: border-box;
    background-color: #ff2270;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: vw(99);
    color: #fff;
    font-size: vw(16);
    font-weight: 500;
    position: fixed;
    bottom: vw(10);
    bottom: calc(#{vw(10)} + constant(safe-area-inset-bottom));
    bottom: calc(#{vw(10)} + env(safe-area-inset-bottom));
    z-index: 9;
  }
}
.container-img {
  background-color: #dc0050;
  padding-bottom: vw(20);
  .nps-top {
    background-color: #dc0050;
    border: none;
    color: #fff !important;
    .left-course {
      span {
        color: #fff !important;
      }
    }
    .left-time {
      color: #fff !important;
    }
    .currprogress-region {
      background-color: #b6003a !important;
      .progress-pop {
        color: #000;
      }
      .progress {
        background-color: #fff !important;
      }
    }
  }
  .nps-position {
    margin-top: 0;
  }
}
.ai-review-entry-img {
  width: vw(375);
  display: block;
}
.nps-top-no-mt {
  margin-top: 0 !important;
}
</style>
